import {Component, OnInit} from '@angular/core';
import {RxComponent} from '../../../../core/components/common/rx.component';
import {SurchargesService} from './surcharges.service';
import { Router } from '@angular/router';

@Component({
    selector: 'itpx-surcharges',
    templateUrl: './surcharges.component.html',
    styleUrls: ['./surcharges.component.css']
})
export class SurchargesComponent extends RxComponent implements OnInit {

    public initialized: boolean = false;
    public tableFields: any = [];
    public surchargesListApi = null;
    public detailsRoute: string = '/agora/product-data/surcharges/{{key}}/details';

    constructor(private surchargeService: SurchargesService, private router: Router) {
        super();
    }

    ngOnInit() {
        this.initiateCampaignTable();
        this.initialized = true;
    }

    initiateCampaignTable() {
        this.tableFields.push({
            title: 'Key',
            name: 'key',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'Name',
            name: 'name'
        }, {
            title: 'Type',
            name: 'type',
            config: {
                type: 'map',
                map: {
                    'fixed': 'Fixed',
                    'percentage': 'Percentage'
                }
            }
        });
        this.surchargesListApi = this.surchargeService.fetchAllSurchargesAPI();
    }

    onAddNewClick() {
        this.router.navigate(['/agora/product-data/surcharges/add']);
    }
 }



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/surcharges/surcharges.component.ts